export var SecurityScanConclusion;
(function (SecurityScanConclusion) {
    SecurityScanConclusion["Clean"] = "CLEAN";
    SecurityScanConclusion["HighChanceForRansomware"] = "HIGH_CHANCE_FOR_RANSOMWARE";
    SecurityScanConclusion["DataAnomalyDetected"] = "DATA_ANOMALY_DETECTED";
    SecurityScanConclusion["MalwareDetected"] = "MALWARE_DETECTED";
    SecurityScanConclusion["AiDataRiskDetected"] = "AI_DATA_RISK_DETECTED";
    SecurityScanConclusion["DataExposureRiskDetected"] = "DATA_EXPOSURE_RISK_DETECTED";
})(SecurityScanConclusion || (SecurityScanConclusion = {}));
